import getCharts from '../getCharts'
import { ApplicationType } from '../../constants/api.config'

export default async function ApplicationTypeFn(mode, Id="",Name="",Link="",LoginID="",PasswordID="",SubmitID="",VPN="",Login="",Extra="") {
  try {
    const jsonData = {Id,Name,Link,LoginID,PasswordID,SubmitID,VPN,Login,Extra}
    const payload = {mode,jsonData:JSON.stringify(jsonData)}
    const res = await getCharts(ApplicationType, payload)
    return res.data
  } catch (error) {
    return error
  }
}
